"use client";

import { useEffect, useRef } from "react";
import { useSearchBox } from "react-instantsearch";
import { logMeiliPerf } from "@/core/search/debug";

export default function SearchQueryConnector({
  query,
  debounceMs = 300,
  debugLabel,
}: {
  query?: string;
  debounceMs?: number;
  debugLabel?: string;
}) {
  const { refine } = useSearchBox();
  const previousQueryRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const normalizedQuery = query ?? "";

    if (previousQueryRef.current === normalizedQuery) {
      return;
    }

    const timer = setTimeout(() => {
      previousQueryRef.current = normalizedQuery;
      refine(normalizedQuery);
      logMeiliPerf("query-refine", {
        debugLabel: debugLabel ?? "search",
        queryLength: normalizedQuery.length,
        debounceMs,
      });
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [debounceMs, debugLabel, query, refine]);

  return null;
}
